module.exports = __webpack_public_path__ + "media/icons/play-da8e892f.svg";